export default function($) {
  var speed = 90; // ms
  var parentCategory = $('.js-parent-category');

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('nav-trigger-active');
  });

  if( $(window).width() > 960 ) {
    parentCategory.hover(
      function () {
        $(this).addClass('bg-primary-light');
        $('ul', this).stop().slideDown(speed);
      },
      function () {
        $(this).removeClass('bg-primary-light');
        $('ul', this).stop().slideUp(speed);
      },
    );
  }

  $(window).on('resize', function() {
    if( $(window).width() > 960 ) {
      $('.js-nav-items').show();
    } else {
      $('.js-nav-items').hide();
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });

  // Product cat nav on mobile

  var productNav = $('.product-cat-nav-items'),
      openProductNav = $('.js-product-cat-trigger'),
      closeProductNav = $('.js-product-cat-close');

  openProductNav.on('click', function() {
    if( !productNav.hasClass('open') ) {
      productNav.addClass('open');
      openProductNav.find('.icon').toggleClass('fill-grey-darker fill-primary');
    }
  });

  closeProductNav.on('click', function() {
    if( productNav.hasClass('open') ) {
      productNav.removeClass('open');
      openProductNav.find('.icon').toggleClass('fill-primary fill-grey-darker');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.product-cat-nav').length) {
      if (productNav.hasClass("open")) {
        productNav.removeClass('open');
        openProductNav.find('.icon').toggleClass('fill-primary fill-grey-darker');
      }
    }
  });
}
